// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FriendStatusList-wrapper_ba458e5e resetList","showLarge":"FriendStatusList-showLarge_453ffebd"};